var ApplicationErrorComponent = /** @class */ (function () {
    function ApplicationErrorComponent() {
    }
    return ApplicationErrorComponent;
}());
export { ApplicationErrorComponent };
